// Components==============
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import InterviewModal from 'screens/Match/components/InterviewModal';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import ContactModal from './components/ContactModal';
import Footer from './components/Footer';
import LoginModal from './components/LoginModal';
import Nav from './components/Nav';
import './index.module.scss';
// =========================

export default function Layout({ children }) {
    const { setIsDashboard } = useContext(GlobalContext);

    const { location } = useHistory();

    useEffect(() => {
        if (
            location.pathname.includes('dashboard') ||
            location.pathname.includes('group')
        )
            return setIsDashboard(true);
        setIsDashboard(false);
    }, [location, setIsDashboard]);

    return (
        <div styleName="layout">
            <Nav />
            <div styleName="content">{children}</div>
            <LoginModal />
            <ContactModal />
            <InterviewModal />
            <Footer />
        </div>
    );
}
